import { render, staticRenderFns } from "./discountListPage.vue?vue&type=template&id=04afe27a&scoped=true"
import script from "./discountListPage.vue?vue&type=script&lang=js"
export * from "./discountListPage.vue?vue&type=script&lang=js"
import style0 from "./discountListPage.vue?vue&type=style&index=0&id=04afe27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04afe27a",
  null
  
)

export default component.exports